export enum OperationType {
  BuyAsset = 1, // Покупка актива
  SellAsset = 2, // Продажа актива
  BlockFunds = 3, // Блокировка средств
  UnblockFunds = 4, // Разблокировка средств
  DealFee = 5, // Комиссия за сделку
  SuccessFee = 6, // Комиссия Success Fee
  UnlockAsset = 7, // Разблокировка актива
}
